"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../constants");
var map = (_a = {},
    _a[constants_1.TextLabel.LOGO_LABEL] = 'Watch on site',
    _a[constants_1.TextLabel.LOGO_TOOLTIP] = 'Watch On Site',
    _a[constants_1.TextLabel.LIVE_INDICATOR_TEXT] = function (_a) {
        var isEnded = _a.isEnded;
        return !isEnded ? 'Live' : 'Live Ended';
    },
    _a[constants_1.TextLabel.LIVE_SYNC_LABEL] = 'Sync to live',
    _a[constants_1.TextLabel.LIVE_SYNC_TOOLTIP] = 'Sync to Live',
    _a[constants_1.TextLabel.PAUSE_CONTROL_LABEL] = 'Pause',
    _a[constants_1.TextLabel.PLAY_CONTROL_LABEL] = 'Play',
    _a[constants_1.TextLabel.PROGRESS_CONTROL_LABEL] = 'Progress control',
    _a[constants_1.TextLabel.PROGRESS_CONTROL_VALUE] = function (_a) {
        var percent = _a.percent;
        return "Already played ".concat(percent, "%");
    },
    _a[constants_1.TextLabel.MUTE_CONTROL_LABEL] = 'Mute',
    _a[constants_1.TextLabel.MUTE_CONTROL_TOOLTIP] = 'Mute',
    _a[constants_1.TextLabel.UNMUTE_CONTROL_LABEL] = 'Unmute',
    _a[constants_1.TextLabel.UNMUTE_CONTROL_TOOLTIP] = 'Unmute',
    _a[constants_1.TextLabel.VOLUME_CONTROL_LABEL] = 'Volume control',
    _a[constants_1.TextLabel.VOLUME_CONTROL_VALUE] = function (_a) {
        var volume = _a.volume;
        return "Volume is ".concat(volume, "%");
    },
    _a[constants_1.TextLabel.ENTER_FULL_SCREEN_LABEL] = 'Enter full screen',
    _a[constants_1.TextLabel.ENTER_FULL_SCREEN_TOOLTIP] = 'Enter Full Screen',
    _a[constants_1.TextLabel.EXIT_FULL_SCREEN_LABEL] = 'Exit full screen',
    _a[constants_1.TextLabel.EXIT_FULL_SCREEN_TOOLTIP] = 'Exit Full Screen',
    _a[constants_1.TextLabel.ENTER_PICTURE_IN_PICTURE_LABEL] = 'Play Picture-in-Picture',
    _a[constants_1.TextLabel.ENTER_PICTURE_IN_PICTURE_TOOLTIP] = 'Play Picture-in-Picture',
    _a[constants_1.TextLabel.EXIT_PICTURE_IN_PICTURE_LABEL] = 'Exit Picture-in-Picture',
    _a[constants_1.TextLabel.EXIT_PICTURE_IN_PICTURE_TOOLTIP] = 'Exit Picture-in-Picture',
    _a[constants_1.TextLabel.DOWNLOAD_BUTTON_LABEL] = 'Download video',
    _a[constants_1.TextLabel.DOWNLOAD_BUTTON_TOOLTIP] = 'Download Video',
    _a);
exports.default = map;
//# sourceMappingURL=default-texts.js.map